import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import { FormSelectInput } from "form";
import {
  actionFormValue,
  actionInputName,
} from "components/action-modal/utils/inputName";
import { setFromArrayOfObjects } from "utils/filterObject";
import { sortObjectsByProperty } from "utils/sortUtils";

const BrandNameSelectInput = ({
  substances,
  selectedPesticideId,
  isProposed,
  isViewMode,
}) => {
  const { t } = useTranslation();

  const { values } = useFormikContext();

  const brandNameOptions = useBrandNameOptions({
    substances,
    pesticideId: selectedPesticideId,
    isProposed,
    isViewMode,
  });

  const isDisabled = !values?.drugAction?.composition;

  return (
    <FormSelectInput
      name={actionInputName("drugAction", "brandName", isProposed)}
      label={isViewMode ? t("ActionModal.BrandName") : undefined}
      placeholder={t("ActionModal.BrandName")}
      shouldHaveErrorBehaviorAfterSubmit
      isDisabled={isDisabled}
      isViewMode={isViewMode}
      options={brandNameOptions}
    />
  );
};

export default BrandNameSelectInput;

const useBrandNameOptions = ({
  substances,
  pesticideId,
  isProposed,
  isViewMode,
}) => {
  const { values } = useFormikContext();
  const selectedSubstance = useMemo(
    () => substances?.[pesticideId],
    [substances, pesticideId],
  );

  const brandNameOptions = useMemo(() => {
    if (isViewMode && isProposed) {
      return [
        {
          value: values?.proposedAction?.brandName,
          label: values?.proposedAction?.brandName,
          group: "notRecommended",
        },
      ];
    }

    const options = setFromArrayOfObjects(
      selectedSubstance?.value.map(({ agrochemicalRead }) => agrochemicalRead),
      "brandName",
    )
      ?.filter((agrochemicalRead) => {
        return (
          agrochemicalRead?.composition + "" ===
            actionFormValue(values, "drugAction", "composition", isProposed) +
              "" &&
          agrochemicalRead?.compositionUnits ===
            actionFormValue(
              values,
              "drugAction",
              "compositionUnits",
              isProposed,
            )
        );
      })
      .map((agrochemicalRead) => ({
        label: agrochemicalRead?.brandName,
        value: agrochemicalRead?.brandName,
      }))
      .sort((a, b) => sortObjectsByProperty(a, b, "label"));
    return options;
  }, [selectedSubstance, values, isProposed, isViewMode]);

  return brandNameOptions;
};
